module.exports = __webpack_public_path__ + "img/6.098a4530.png";